/** 与 AIGC 独立站点 Layout 一致的侧边栏菜单 */
export const AIGC_MENU_GROUPS = [
  {
    title: "创作中心",
    items: [
      { key: "aigc_home", label: "首页", icon: "wap-home-o" },
      { key: "lm_projects", label: "项目管理", icon: "orders-o" },
    ],
  },
  {
    title: "资产管理",
    items: [
      { key: "lm_assets_roles", label: "角色库", icon: "user-o" },
      { key: "lm_assets_scenes", label: "场景库", icon: "location-o" },
      { key: "lm_assets_props", label: "道具库", icon: "gem-o" },
      { key: "lm_assets_generate", label: "生成库", icon: "photo-o" },
      { key: "lm_assets_favorites", label: "我的收藏", icon: "star-o" },
    ],
  },
  {
    title: "账户",
    items: [
      { key: "recharge", label: "充值", icon: "gold-coin-o" },
      { key: "amount_detail", label: "账单明细", icon: "balance-list-o" },
    ],
  },
  {
    title: "帮助",
    items: [
      { key: "lm_works", label: "创作案例", icon: "photo-o" },
      { key: "lm_guide", label: "创作指引", icon: "info-o" },
      { key: "aigc_real_human_liveness", label: "真人素材授权", icon: "contact" },
      { key: "order_class", label: "工单反馈", icon: "description" },
    ],
  },
];

/** 手机 H5 站内路由 */
const MOBILE_ROUTE_NAMES = {
  aigc_home: "aigc_create",
  aigc_create: "aigc_create",
  aigc_real_human_liveness: "aigc_real_human_liveness",
  order_class: "order_class",
  recharge: "recharge",
  amount_detail: "amount_detail",
};

/** AIGC 独立站点 hash 路径 */
const AIGC_FRONT_ROUTE_HASH = {
  lm_home: "/aigc/home",
  lm_projects: "/aigc/projects",
  lm_image_create: "/aigc/create",
  lm_assets_roles: "/aigc/assets/roles",
  lm_assets_scenes: "/aigc/assets/scenes",
  lm_assets_props: "/aigc/assets/props",
  lm_assets_generate: "/aigc/assets/generate",
  lm_assets_favorites: "/aigc/assets/favorites",
  lm_recharge: "/aigc/recharge",
  lm_amount_detail: "/aigc/amount-detail",
  lm_works: "/aigc/works",
  lm_guide: "/aigc/guide",
};

export function getAigcFrontOrigin() {
  const raw = process.env.AIGC_FRONT_URL || "";
  return String(raw).replace(/^["']|["']$/g, "").replace(/\/+$/, "");
}

export function getAigcFrontUrl(routeKey) {
  const hash = AIGC_FRONT_ROUTE_HASH[routeKey];
  if (!hash) return "";
  const origin = getAigcFrontOrigin() || "https://aigc.ibaicloud.com";
  return `${origin}/#${hash}`;
}

export function getAigcProjectsUrl() {
  const origin = getAigcFrontOrigin() || "https://aigc.ibaicloud.com";
  return `${origin}/#/aigc/projects`;
}

export function isMobileNavRoute(routeKey) {
  return !!MOBILE_ROUTE_NAMES[routeKey];
}

export function getMobileRouteName(routeKey) {
  return MOBILE_ROUTE_NAMES[routeKey] || "";
}



// WEBPACK FOOTER //
// ./src/views/aigc/aigcNavConfig.js